<template>
    <v-layout row wrap>
        <v-tabs dark centered>

            <v-tabs-bar class="grey darken-3">                      

                <v-tabs-item href="#tab1" >
                    <v-btn flat class="grey--text">
                        O Auth Clients
                    </v-btn>
                </v-tabs-item>
                <v-tabs-item href="#tab2" >
                    <v-btn flat class="grey--text">
                        Authorized Apps
                    </v-btn>
                </v-tabs-item>
                <v-tabs-item href="#tab3">
                    <v-btn flat class="grey--text">
                        Personal Tokens
                    </v-btn>

                </v-tabs-item>   
                <v-tabs-slider class="orange"></v-tabs-slider>
            </v-tabs-bar>
            <v-tabs-items>
                <v-tabs-content id="tab1">
                    <div>
                        <keep-alive>
                            <form-one></form-one>
                        </keep-alive>
                    </div>
                </v-tabs-content>

                <v-tabs-content id="tab2">
                    <div>
                        <keep-alive>
                            <form-two></form-two>
                        </keep-alive>
                    </div>
                </v-tabs-content>

                   <v-tabs-content id="tab3">
                    <div>
                        <keep-alive>
                            <form-three></form-three>
                        </keep-alive>
                    </div>
                </v-tabs-content>
            </v-tabs-items>
        </v-tabs>
    </v-layout>         
</template>

<script>

import formTwo from './AuthorizedClients.vue';
import formOne from './Clients.vue';
import formThree from './PersonalAccessTokens.vue';

export default {
    components: {        
        'form-one': formOne,
        'form-two': formTwo,
        'form-three': formThree,
        
    },
    data() {
        return {
                   
        }
    }, 
    computed: {
        loading: function() {
            return this.$store.getters.loading
        },
        
    },
    
    
    
}
</script>

<style>
    
    
</style>



// WEBPACK FOOTER //
// Passport.vue?622f6de4